import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import Header from "../../components/ui/Header";
import Button from "../../components/ui/Button";
import Input from "../../components/ui/Input";

import BannerAdsTable from "./components/BannerAdsCrudTable";
import BannerAdsFormModal from "./components/BannerAdsFormModal";
import DeleteConfirmModal from "./components/DeleteConfirmModal";

import {
  createAdvertismentService,
  getAdvertisementsService,
  updateAdvertisementService,
  deleteAdvertismentService,
} from "redux/services/general_service";

import { toast } from "react-toastify";

const BannerAdsCrudManagement = () => {
  const dispatch = useDispatch();
  const { advertisment, metaAdvertismentCode } = useSelector(
    (state) => state.general
  );

  const [language] = useState("ar");
  const [page, setPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");

  const [selectedAd, setSelectedAd] = useState(null);
  const [mode, setMode] = useState("add");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  // ==========================
  // 🔹 Fetch Ads
  // ==========================
  useEffect(() => {
    dispatch(getAdvertisementsService({ page, search: searchQuery }));
  }, [dispatch, page, searchQuery]);

  // ==========================
  // 🔹 Save (Create / Update)
  // ==========================
  const handleSave = async (data) => {
    console.log(data)
    try {
      const formData = new FormData();
      formData.append("title", data.title);
      formData.append("body", data.body);
         formData.append("advertisement_type", data.advertisement_type);
      if (data.image instanceof File) formData.append("image", data.image);

      if (mode === "add") {
        await dispatch(createAdvertismentService(formData));
        toast.success("Banner added successfully!");
      } else {
        await dispatch(
          updateAdvertisementService({ id: selectedAd.id, formData })
        );
        toast.success("Banner updated successfully!");
      }

      setIsModalOpen(false);
      dispatch(getAdvertisementsService({ page, search: searchQuery }));
    } catch (error) {
      console.error(error);
      toast.error("Error saving banner.");
    }
  };

  // ==========================
  // 🔹 Delete
  // ==========================
  const handleDelete = async () => {
    try {
      await dispatch(deleteAdvertismentService(selectedAd.id));
      toast.success("Banner deleted successfully!");
      setIsDeleteModalOpen(false);
      dispatch(getAdvertisementsService({ page, search: searchQuery }));
    } catch (error) {
      console.error(error);
      toast.error("Error deleting banner.");
    }
  };

  return (
    <div className="min-h-screen bg-background">
      <Header />

      <div className="container mx-auto p-6">
        {/* Header */}
        <div className="flex flex-col md:flex-row justify-between items-center mb-4 gap-4">
          <h1 className="text-2xl font-bold">إدارة الإعلانات</h1>

          <div className="flex gap-2">
            <Input
              type="search"
              placeholder="البحث عن إعلان ..."
              value={searchQuery}
              onChange={(e) => {
                setSearchQuery(e.target.value);
                setPage(1);
              }}
              className="md:max-w-sm"
            />

            <Button
              onClick={() => {
                setMode("add");
                setSelectedAd(null);
                setIsModalOpen(true);
              }}
            >
              إضافة إعلان
            </Button>
          </div>
        </div>

        {/* Table */}
        <BannerAdsTable
          bannerAds={advertisment}
          metaBannerAds={metaAdvertismentCode}
          onPageChange={(p) => setPage(p)}
          onEdit={(ad) => {
            setSelectedAd(ad);
            setMode("edit");
            setIsModalOpen(true);
          }}
          onDelete={(ad) => {
            setSelectedAd(ad);
            setIsDeleteModalOpen(true);
          }}
        />
      </div>

      {/* Form Modal */}
      {isModalOpen && (
        <BannerAdsFormModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          onSave={handleSave}
          bannerAd={selectedAd}
          mode={mode}
          language={language}
        />
      )}

      {/* Delete Modal */}
      {isDeleteModalOpen && (
        <DeleteConfirmModal
          isOpen
          onClose={() => setIsDeleteModalOpen(false)}
          onConfirm={handleDelete}
          itemName={selectedAd?.title}
          language={language}
        />
      )}
    </div>
  );
};

export default BannerAdsCrudManagement;
